import { isPrerender } from '../utils/prerender'

let observer

const reveal = el => {
  el.classList.remove('is-pending')
  el.classList.add('is-visible')
}

const prefersReducedMotion = () => {
  return typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

const isInViewport = el => {
  if (typeof window === 'undefined') return true
  const rect = el.getBoundingClientRect()
  return rect.top < window.innerHeight && rect.bottom > 0
}

const getObserver = () => {
  if (!observer) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          reveal(entry.target)
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' })
  }
  return observer
}

export default {
  inserted: (el, binding) => {
    el.classList.add('scroll-reveal')
    if (typeof binding.value === 'number') {
      el.style.transitionDelay = `${binding.value * 150}ms`
    }

    if (isPrerender() || prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
      reveal(el)
      return
    }

    if (isInViewport(el)) {
      reveal(el)
      return
    }

    el.classList.add('is-pending')
    getObserver().observe(el)
  }
}
